import { useRouter } from 'next/router';
import { ReactNode, useCallback } from 'react';
import { buildLoginPageUrl } from '@/dashboard/utils/auth';
import { JoveAuthProvider as SharedJoveAuthProvider } from '@jove-frontend/ui';

interface JoveAuthProviderProps {
  children: ReactNode;
}

/**
 * Auth0-compatible auth context for the dashboard app, backed by the shared backend session.
 * Redirects to the login page restore the persisted login page context (prefilled email, portal variant).
 */
const JoveAuthProvider = ({ children }: JoveAuthProviderProps) => {
  const router = useRouter();

  const buildLoginUrl = useCallback(() => buildLoginPageUrl(router.query), [router.query]);

  return <SharedJoveAuthProvider buildLoginPageUrl={buildLoginUrl}>{children}</SharedJoveAuthProvider>;
};

export default JoveAuthProvider;
